import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QPlaceholderComponent } from './q-placeholder.component';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@xref/ngx';

@NgModule({
  declarations: [QPlaceholderComponent],
  imports: [
    CommonModule,
    TranslateModule,
    MatButtonModule
  ],
  exports: [QPlaceholderComponent]
})
export class QPlaceholderModule {}
